module.exports = __webpack_public_path__ + "k/static/img/top.1a8b7128.png";